(function ($) {
  $(document).ready(function () {
    // Getting localized data.
    var authObj = localizedData.authScript;
    // Validate email address.
    $.validator.addMethod(
      "validEmail",
      function (value, element) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
      },
      "Please enter a valid email address."
    );

    // Validation method to ensure the value contains no spaces or is empty.
    $.validator.addMethod("noSpace", function (value) {
      return value == "" || value.trim().length != 0;
    });

    // Has a Digit
    $.validator.addMethod("pwnumber", function (value) {
      return /\d/.test(value); // has a digit
    });

    // Has a Special Character
    $.validator.addMethod("pwspecialchar", function (value) {
      return /([~!@#$%^&*()_+=`{}\[\]\-|\\:;'<>,.\/? ])+/g.test(value); // Special Character
    });

    // Validate registration form.
    $("#akd_registration_form").validate({
      rules: {
        fname: {
          required: true,
          noSpace: true,
        },
        lname: {
          required: true,
          noSpace: true,
        },
        remail: {
          required: true,
          validEmail: true,
        },
        rpass: {
          required: true,
          pwnumber: true,
          pwspecialchar: true,
          minlength: 8,
        },
        rcpass: {
          required: true,
          equalTo: "input[name='rpass']",
        },
      },
      messages: {
        fname: {
          required: "This field is required.",
          noSpace: "Please enter a valid name",
        },
        lname: {
          required: "This field is required.",
          noSpace: "Please enter a valid name",
        },
        remail: {
          required: "This field is required.",
        },
        rpass: {
          required: "Please provide password.",
          pwnumber: "Please include at least one digit.",
          pwspecialchar: "Please include at least one special character.",
          minlength: "Your password must be at least 8 characters long.",
        },
        rcpass: {
          required: "Please provide password.",
          equalTo: "Please enter the same password as above.",
        },
      },
      submitHandler: function (form) {
        var form = new FormData($("#akd_registration_form")[0]);
        form.append("action", "user_register");
        form.append("nonce", authObj.register_nonce);
        $.ajax({
          url: authObj.ajax_url,
          type: "post",
          processData: false,
          contentType: false,
          data: form,
          beforeSend: function () {
            $("#akd_registration_form input[type=submit]").attr(
              "disabled",
              "disabled"
            );
            $("#akd_registration_form input").attr("readonly", true);
            $(".register-loader").show();
          },
          success: function (data) {
            $("#akd_registration_form input").attr("readonly", false);
            $("#akd_registration_form input[type=submit]").removeAttr(
              "disabled"
            );
            $(".register-loader").hide();
            var regStatus = data.status;
            var regMessage = data.message;
            if (regStatus === true) {
              $("form#akd_registration_form").trigger("reset");
              $(".reg-message").addClass("success");
              $(".reg-message").html(regMessage);
              location.reload();
            } else {
              $(".reg-message").addClass("error");
              $(".reg-message").html(regMessage);
            }
          },
          error: function () {
            $("#akd_registration_form input").attr("readonly", false);
            $("#akd_registration_form input[type=submit]").removeAttr(
              "disabled"
            );
            $(".register-loader").hide();
            $(".reg-message").html("An error occurred. Please try again.");
          },
        });
      },
    });

    // Validate login form.
    $("#akd_login_form").validate({
      rules: {
        lemail: {
          required: true,
          validEmail: true,
        },
        lpass: {
          required: true,
        },
      },
      messages: {
        lemail: {
          required: "Please enter a valid email address",
        },
        lpass: {
          required: "Please provide password.",
        },
      },
      submitHandler: function (form) {
        var form = new FormData($("#akd_login_form")[0]);
        form.append("action", "user_login");
        form.append("nonce", authObj.login_nonce);
        $.ajax({
          url: authObj.ajax_url,
          type: "post",
          processData: false,
          contentType: false,
          data: form,
          beforeSend: function () {
            $("#akd_login_form input[type=submit]").attr(
              "disabled",
              "disabled"
            );
            $("#akd_login_form input").attr("readonly", true);
            $(".login-loader").show();
          },
          success: function (data) {
            $("#akd_login_form input").attr("readonly", false);
            $("#akd_login_form input[type=submit]").removeAttr("disabled");
            $(".login-loader").hide();
            var loginStatus = data.status;
            var loginMessage = data.message;
            if (loginStatus === true) {
              $("form#akd_login_form").trigger("reset");
              $(".login-message").addClass("success");
              $(".login-message").html(loginMessage);
              location.reload();
            } else {
              $(".login-message").addClass("error");
              $(".login-message").html(loginMessage);
            }
          },
          error: function () {
            $("#akd_login_form input").attr("readonly", false);
            $("#akd_login_form input[type=submit]").removeAttr("disabled");
            $(".login-loader").hide();
            $(".login-message").html("An error occurred. Please try again.");
          },
        });
      },
    });

    // Validate forgot password form.
    $("#akd_forgot_password_form").validate({
      rules: {
        fpemail: {
          required: true,
          validEmail: true,
        },
      },
      messages: {
        fpemail: {
          required: "Please enter a valid email address",
        },
      },
      submitHandler: function (form) {
        var form = new FormData($("#akd_forgot_password_form")[0]);
        form.append("action", "forgot_password");
        form.append("nonce", authObj.forgot_pass_nonce);
        $.ajax({
          url: authObj.ajax_url,
          type: "post",
          processData: false,
          contentType: false,
          data: form,
          beforeSend: function () {
            $("#akd_forgot_password_form input[type=submit]").attr(
              "disabled",
              "disabled"
            );
            $("#akd_forgot_password_form input").attr("readonly", true);
            $(".fp-loader").show();
          },
          success: function (data) {
            $("#akd_forgot_password_form input").attr("readonly", false);
            $("#akd_forgot_password_form input[type=submit]").removeAttr(
              "disabled"
            );
            $(".fp-loader").hide();
            var fpStatus = data.status;
            var fpMessage = data.message;
            if (fpStatus === true) {
              $("form#akd_forgot_password_form").trigger("reset");
              $(".fp-message").addClass("success");
              $(".fp-message").html(fpMessage);
            } else {
              $(".fp-message").addClass("error");
              $(".fp-message").html(fpMessage);
            }
          },
          error: function () {
            $("#akd_forgot_password_form input").attr("readonly", false);
            $("#akd_forgot_password_form input[type=submit]").removeAttr(
              "disabled"
            );
            $(".fp-loader").hide();
            $(".fp-message").html("An error occurred. Please try again.");
          },
        });
      },
    });

    // Validate reset password form.
    $("#akd_reset_password_form").validate({
      rules: {
        resetpass: {
          required: true,
          pwnumber: true,
          pwspecialchar: true,
          minlength: 10,
        },
        resetcpass: {
          required: true,
          equalTo: "input[name='resetpass']",
        },
      },
      messages: {
        resetpass: {
          required: "Please provide password.",
          pwnumber: "Please include at least one digit.",
          pwspecialchar: "Please include at least one special character.",
          minlength: "Your password must be at least 10 characters long.",
        },
        resetcpass: {
          required: "Please provide password.",
          equalTo: "Please enter the same password as above.",
        },
      },
      submitHandler: function (form) {
        var form = new FormData($("#akd_reset_password_form")[0]);
        form.append("action", "reset_password");
        form.append("nonce", authObj.reset_pass_nonce);
        $.ajax({
          url: authObj.ajax_url,
          type: "post",
          processData: false,
          contentType: false,
          data: form,
          beforeSend: function () {
            $("#akd_reset_password_form input[type=submit]").attr(
              "disabled",
              "disabled"
            );
            $("#akd_reset_password_form input").attr("readonly", true);
            $(".rp-loader").show();
          },
          success: function (data) {
            $("#akd_reset_password_form input").attr("readonly", false);
            $("#akd_reset_password_form input[type=submit]").removeAttr(
              "disabled"
            );
            $(".rp-loader").hide();
            var rpStatus = data.status;
            var rpMessage = data.message;
            if (rpStatus === true) {
              $("form#akd_reset_password_form").trigger("reset");
              $(".rp-message").addClass("success");
              $(".rp-message").html(rpMessage);
            } else {
              $(".rp-message").addClass("error");
              $(".rp-message").html(rpMessage);
            }
          },
          error: function () {
            $("#akd_reset_password_form input").attr("readonly", false);
            $("#akd_reset_password_form input[type=submit]").removeAttr(
              "disabled"
            );
            $(".rp-loader").hide();
            $(".rp-message").html("An error occurred. Please try again.");
          },
        });
      },
    });

    // Toggle password visibility.
    $(".pass-with-eye img").on("click", function () {
      var $this = $(this);
      var $input = $this.siblings("input.password");

      if ($input.attr("type") === "password") {
        $input.attr("type", "text");
        $this.hide();
        $this.siblings(".visible-pass").show();
        $this.siblings(".invisible-pass").hide();
      } else {
        $input.attr("type", "password");
        $this.hide();
        $this.siblings(".invisible-pass").show();
        $this.siblings(".visible-pass").hide();
      }
    });

    // Open register modal.
    $(".register-modal").on("click", function () {
      $("#akd-user-login").hide();
      $("#akd-user-registration").show();
    });

    // Open login modal.
    $(".login-modal").on("click", function () {
      $("#akd-user-registration").hide();
      $("#akd-user-login").show();
    });

    // Open login modal.
    $("#akd-auth-modal").on("click", function () {
      $(".user-login-container").show();
    });

    // Open login modal.
    $("#akd-auth-modal-mobile").on("click", function () {
      $(".user-login-container").show();
    });
  });
})(jQuery);
